module.exports = __webpack_public_path__ + "img/15.7b37c790.png";